import React, { useState } from 'react';
import './MainMenu.css'; // create or include styles here

const MainMenu = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="main-menu-container">
      <button className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        ☰
      </button>

      <ul className={`main-menu ${mobileMenuOpen ? 'open' : ''}`}>
      
		 <li><a href="/about">About Us</a></li>
        <li><a href="/student-life">Student Life</a></li>
        <li><a href="/mandatory-disclosure">Mandatory Disclosure</a></li>
        <li><a href="/laboratory">Laboratory</a></li>
        <li><a href="/gallery">Gallery</a></li>
        <li><a href="/club-activities">Club Activities</a></li>
        <li><a href="/awards">Achievements and Awards</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </nav>
  );
};

export default MainMenu;
